/* The commented out benefits and workforces should be uncommented once the data is available */

export const getBenefitsList = () => {
  return [
    {id: 1, title: 'SNAP', label: 'SNAP', key: 'usdaSnapInd', enrolledKey: 'snapEnrolled'}
    // {id: 2, title: 'Medicare', label: 'Medicare', key: 'medicareEligInd', enrolledKey: 'medicareEnrolled'},
    // {id: 3, title: 'Medicaid', label: 'Medicaid', key: 'medicaidEligInd', enrolledKey: 'medicaidEnrolled'}
  ]
}

export const getWorkforcesList = () => {
  return [
    // {
    //   id: 1,
    //   title: 'Electricians and Installers',
    //   label: 'Electricians and Installers',
    //   enrolledKey: 'electricianRecruitmentEnrolled'
    // }
  ]
}

export const getSdohBenefitKeys = () => {
  return ['usdaSnapInd', 'medicaidEligInd']
}

/**
 * Determines the current Prism program based on the URL.
 * @returns {string} Returns 'PeoplePrism' if the URL contains 'peopleprism', otherwise returns 'HealthPrism'.
 */
export const getPrismProgram = () => {
  let prismProgram = 'HealthPrism'
  const currentUrl = globalThis.location.href
  if (currentUrl?.includes('peopleprism')) {
    prismProgram = 'PeoplePrism'
  }
  return prismProgram
}
